import { render } from "./BottomNavigation.vue?vue&type=template&id=79e3094b&scoped=true&ts=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"

import "./BottomNavigation.vue?vue&type=style&index=0&id=79e3094b&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e3094b"]])

export default __exports__